<form (ngSubmit)="submit()" class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
        <label class="form-label">{{
            'translate_result_analysis_in_arabic' | translate
        }}</label>
        <textarea
            dir="rtl"
            class="w-full"
            [disabled]="
                type === 'data-entry-response'
                    ? !canEditResultAnalysis || readOnly
                    : isApproved ||
                      (!allowDynamicAnalysisEdit && !canEditResultAnalysis)
            "
            [(ngModel)]="resultAnalysisAr"
            [ngModelOptions]="{ standalone: true }"
        ></textarea>
    </div>

    <div class="flex flex-col gap-2">
        <label class="form-label">{{
            'translate_result_analysis_in_english' | translate
        }}</label>
        <textarea
            dir="ltr"
            class="w-full"
            [disabled]="
                type === 'data-entry-response'
                    ? !canEditResultAnalysis || readOnly
                    : isApproved ||
                      (!allowDynamicAnalysisEdit && !canEditResultAnalysis)
            "
            [(ngModel)]="resultAnalysisEn"
            [ngModelOptions]="{ standalone: true }"
        ></textarea>
    </div>

    @if (
        type === 'data-entry-response'
            ? canEditResultAnalysis && !readOnly
            : !isApproved && (allowDynamicAnalysisEdit || canEditResultAnalysis)
    ) {
        <div class="mt-2 text-center">
            <ng-container [ngTemplateOutlet]="buttonTemplate"></ng-container>
        </div>
    }
</form>

<ng-template #buttonTemplate>
    <button type="submit" class="btn btn-lg btn-primary">
        <i class="fa-light fa-save me-2"></i>
        <span>{{ 'translate_save' | translate }}</span>
    </button>
</ng-template>
